import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>


                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="leftimg"><img
                                                src={require('@images/why-do-we-need-to-improve-processes-next_01.png')}
                                                alt=""/></div>
                                            <div className="paraspace"><p>If the answers given during the
                                                identification phase don’t provide an obvious solution then
                                                you need a thorough consultation phase. Think about the
                                                following:</p></div>
                                            <ul className="greenbullet-list uiheading thought-list-pad">
                                                <li><p>Who has been affected by the process?</p></li>
                                                <li><p>Who would be affected by the improvement?</p></li>
                                                <li><p>How widespread has the problem been?</p></li>
                                                <li><p>Are all people following the process correctly?</p>
                                                </li>
                                                <li><p>What do people feel the solution is?</p></li>
                                                <li><p>Is the solution a ‘simple fix’ or does it involve
                                                    total renewal?</p></li>
                                            </ul>
                                            <div className="paraspace"><p>Make a point of consulting people
                                                who use the process – not just a small group of
                                                managers:</p></div>

                                            <ol className="testclass1">
                                                <li><p className="further_info_content">It’s reasonable that
                                                    people who use the process are qualified to offer
                                                    ideas.</p></li>
                                                <li><p className="further_info_content">They will feel
                                                    included in the process which then makes it easier to
                                                    introduce changes.</p></li>
                                            </ol>


                                            <p>If this phase has been conducted properly then you should
                                                have a clear understanding of the problem plus some ideas
                                                for correcting it. This is the stage where you’ll be able to
                                                tell whether a bit of tweaking is all that’s needed, or a
                                                whole new process.</p>
                                            <div className="leftimg"><img
                                                src={require('@images/why-do-we-need-to-improve-processes-next_02.png')}
                                                alt=""/></div>
                                            <p>The review from the Consultation Phase should have given you
                                                enough information to know what to do and the Implementation
                                                Phase assists in the doing of it! It’s vital, however to
                                                review continually throughout the Implementation Phase,
                                                because this is the time to check things are working or
                                                amend as necessary.</p>
                                            <div className="paraspace"><p>So, when planning how to put the
                                                changes in place:</p></div>
                                            <ul className="greenbullet-list uiheading thought-list-pad">
                                                <li><p>Ensure that the person who knows most about the
                                                    process is given the authority and time to change
                                                    things.</p></li>
                                                <li><p>Decide the best course of action and investigate how
                                                    to implement it.</p></li>
                                                <li><p>Get approval for the changes from senior stakeholders
                                                    to help you convince others of the need for change.</p>
                                                </li>
                                                <li><p>Communicate that changes are to take place to all
                                                    concerned in good time and arrange training where
                                                    necessary.</p></li>
                                                <li><p>The process should be documented, kept up to date and
                                                    easily accessible.</p></li>
                                                <li><p>Monitor cost implications.</p></li>
                                            </ul>
                                            <div className="leftimg"><img
                                                src={require('@images/why-do-we-need-to-improve-processes-next_03.png')}
                                                alt=""/></div>
                                            <p>From the moment you consider changing a process, evaluate all
                                                information and facts each step of the way – otherwise,
                                                problems could multiply before you complete!</p>
                                            <p>Post-implementation evaluation should be done after the
                                                process has been given time to fully bed in – remember,
                                                processes that run like clockwork will have been honed and
                                                perfected over time.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}